<template>
  <teleport :to="teleportTo" v-if="isReady">
    <div class="flex py-1 lg:py-2 px-1 justify-between gap-1">
      <div class="flex flex-shrink-0 items-center gap-0 lg:gap-1">
        <template v-if="selection.count.value">
          <core-selection-toolbar-button :icon="COMMON_ICONS.close" @click="selection.clear()" icon-color="text-heroblue">
            {{selection.count.value}} Selected
          </core-selection-toolbar-button>
          <u-divider orientation="vertical" class="h-full" />
        </template>
      </div>
      <div class="-mt-3 min-w-0 flex-1 overflow-x-auto overflow-y-hidden pt-3 pr-1 md:flex md:justify-end">
        <div class="inline-block min-w-max">
          <slot />
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>

  const props = defineProps({
    selectionComposable: Object,
    teleportToId: String
  });

  const selection = props.selectionComposable || useSelection();
  const teleportTo = `#${props.teleportToId || 'selection-toolbar'}`;

  const isReady = ref(false);
  onMounted(async () => {
    await nextTick();
    isReady.value = true;
  });
</script>
